import React, { createContext, useContext, useEffect, useState, useMemo } from 'react';
import ApiService from 'services/ApiService';
import { repeatEffect, settingsConfig } from 'utils/commonFunc';
import { ResponsiveBar } from '@nivo/bar';
import styles from '../../css/trfSfty.module.css';
import { Height } from '@mui/icons-material';
import { siLK } from '@mui/material/locale';


export function RoadSurfaceHistory() {
    const [selectedDate, setSelectedDate] = useState('');
    const [selectedFilter, setSelectedFilter] = useState('');
    const [timeData, setTimeData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    // statCd를 상태 문자열로 변환
    const getStatusFromCode = (statCd) => {
        switch (statCd) {
            case '001': return 'Dry';
            case '003': return 'Wet';
            case '006': return 'Ice';
            case '009': return 'Error';
            default: return 'Unknown';
        }
    };

    // 필터링된 데이터 처리
    const filteredData = useMemo(() => {
        if (!timeData || timeData.length === 0) return [];

        // 데이터를 테이블 형태로 변환
        const tableData = timeData.map(timeEntry => {
            const rowData = {
                time: timeEntry.time,
                timestamp: new Date(`2000-01-01T${timeEntry.time}:00`).getTime() // 시간 비교용
            };

            // 각 지역별 상태 매핑
            timeEntry.rows.forEach(row => {
                const status = getStatusFromCode(row.statCd);
                rowData[row.roadNm] = status;
            });

            return rowData;
        });

        // 필터가 선택된 경우 해당 상태가 있는 시간을 앞으로 정렬
        if (selectedFilter) {
            const filterStatus = selectedFilter === 'WET' ? 'Wet' :
                selectedFilter === 'ICE' ? 'Ice' :
                    selectedFilter === 'error' ? 'Error' : selectedFilter;

            const hasFilterState = tableData.filter(entry =>
                Object.values(entry).some(value => value === filterStatus)
            );

            const noFilterState = tableData.filter(entry =>
                !Object.values(entry).some(value => value === filterStatus)
            );

            // 각각을 시간순으로 정렬한 후 합치기
            const sortedHasFilter = hasFilterState.sort((a, b) => a.timestamp - b.timestamp);
            const sortedNoFilter = noFilterState.sort((a, b) => a.timestamp - b.timestamp);

            return [...sortedHasFilter, ...sortedNoFilter];
        }

        // 필터가 없으면 시간순 정렬
        return tableData.sort((a, b) => a.timestamp - b.timestamp);
    }, [timeData, selectedFilter]);

    useEffect(() => {
        if (!selectedDate) return;

        const fetchDateData = async () => {
            setIsLoading(true);
            setTimeData([]);
            try {
                const formattedDate = selectedDate.replace(/-/g, '');
                console.log(formattedDate);
                const response = await ApiService.get(`newdashboard/trfsfty/GetRoadLogData?dtm=${formattedDate}`);
                const data = response.data;
                setTimeData(data);
                console.log('API 응답 데이터:', data);
            } catch (error) {
                console.error('데이터 로딩 실패:', error);
                setTimeData([]);
            } finally {
                setIsLoading(false);
            }
        };

        fetchDateData();
    }, [selectedDate]);

    const handleDateChange = (value) => {
        setSelectedDate(value);
    };

    const handleFilterClick = (filter) => {
        setSelectedFilter(selectedFilter === filter ? '' : filter);
    };

    const getSurfaceColor = (surface) => {
        switch (surface?.toLowerCase()) {
            case 'dry': return '#4CAF50';
            case 'wet': return '#FFC414';
            case 'ice': return '#46B1FE';
            case 'error': return '#f44336';
            default: return '#888';
        }
    };

    const getFilterButtonStyle = (filter) => ({
        padding: '8px 60px',
        borderRadius: '40px',
        border: '2px solid',
        borderColor: selectedFilter === filter ? getSurfaceColor(filter) : '#666',
        backgroundColor: selectedFilter === filter ? getSurfaceColor(filter) : 'transparent',
        color: selectedFilter === filter ? 'white' : getSurfaceColor(filter),
        cursor: 'pointer',
        fontSize: '28px',
        fontWeight: '600',
        Height:'80px',
        transition: 'all 0.2s ease'
    });

    return (
        <>
        <div className='road-surface-history flx a_center flx_col gap20' style={{overflow:' hidden !important'}}>
            {/* 날짜 선택 및 필터 영역 */}
            <div className='date-and-filter-section flx a_center gap20 w_100'>
                {/* 날짜 선택 */}
                <div className="date-selector" style={{flex:1}}>
                    <input
                        type="date"
                        className='date'
                        value={selectedDate}
                        onChange={(e) => handleDateChange(e.target.value)}
                        >
                    </input>
                </div>
                {/* 필터 버튼들 */}
                <div className= {`${styles.filterBtn} filter-buttons flx a_center`}>
                    {/* <span style={{ color: 'white', fontSize: '16px', marginRight: '10px' }}>
                        노면 이력 조회</span> */}
                    <button
                        onClick={() => handleFilterClick('WET')}
                        style={getFilterButtonStyle('WET')}
                    >
                        WET
                    </button>
                    <button
                        onClick={() => handleFilterClick('ICE')}
                        style={getFilterButtonStyle('ICE')}
                    >
                        ICE
                    </button>
                    <button
                        onClick={() => handleFilterClick('error')}
                        style={getFilterButtonStyle('error')}
                    >
                        ERROR
                    </button>
                </div>
            </div>

            {/* 로딩 상태 표시 */}
            {isLoading && (
                <div style={{
                    textAlign: 'center',
                    color: '#888',
                    marginTop: '20px',
                    padding: '40px',
                    fontSize: '32px'
                }}>
                    데이터를 불러오는 중...
                </div>
            )}

            {/* 테이블 영역 - 스크롤 가능 */}
            {filteredData.length > 0 && (
                <div className="history-table cst_scroll" 
                style={{
                    width:'100%',
                    overflow:'auto'
                }}>
                    <table style={{
                        width: '100%',
                        borderCollapse: 'collapse',
                    }}>
                        <thead style={{ position: 'sticky', fontSize:'24px', top: 0, zIndex: 10 }}>
                            <tr style={{ backgroundColor: '#1B2138' }}>
                                <th style={{ padding: '20px', color: 'white', textAlign: 'center', minWidth: '80px' }}>시간</th>
                                <th style={{ padding: '20px', color: 'white', textAlign: 'center' }}>버들치터널출구</th>
                                <th style={{ padding: '20px', color: 'white', textAlign: 'center' }}>풍산조리원앞</th>
                                <th style={{ padding: '20px', color: 'white', textAlign: 'center' }}>길마재교하단</th>
                                <th style={{ padding: '20px', color: 'white', textAlign: 'center' }}>먹고보리앞</th>
                                <th style={{ padding: '20px', color: 'white', textAlign: 'center' }}>호반가든하임앞</th>
                            </tr>
                        </thead>
                        <tbody>
                            {filteredData.map((row, index) => (
                                <tr key={`${row.time}-${index}`} style={{
                                    borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
                                }}>
                                    <td style={{
                                        padding: '20px',
                                        color: 'white',
                                        textAlign: 'center',
                                        fontWeight: 'bold',
                                        fontSize: '22px'
                                    }}>
                                        {row.time}
                                    </td>
                                    <td style={{
                                        padding: '20px',
                                        color: getSurfaceColor(row['버들치터널출구']),
                                        textAlign: 'center',
                                        fontWeight: 'bold',
                                        fontSize: '22px'
                                    }}>
                                        {row['버들치터널출구']}
                                    </td>
                                    <td style={{
                                        padding: '20px',
                                        color: getSurfaceColor(row['풍산조리원앞']),
                                        textAlign: 'center',
                                        fontWeight: 'bold',
                                        fontSize: '22px'
                                    }}>
                                        {row['풍산조리원앞']}
                                    </td>
                                    <td style={{
                                        padding: '20px',
                                        color: getSurfaceColor(row['길마재교하단']),
                                        textAlign: 'center',
                                        fontWeight: 'bold',
                                        fontSize: '22px'
                                    }}>
                                        {row['길마재교하단']}
                                    </td>
                                    <td style={{
                                        padding: '20px',
                                        color: getSurfaceColor(row['먹고보리앞']),
                                        textAlign: 'center',
                                        fontWeight: 'bold',
                                        fontSize: '22px'
                                    }}>
                                        {row['먹고보리앞']}
                                    </td>
                                    <td style={{
                                        padding: '20px',
                                        color: getSurfaceColor(row['호반가든하임앞']),
                                        textAlign: 'center',
                                        fontWeight: 'bold',
                                        fontSize: '22px'
                                    }}>
                                        {row['호반가든하임앞']}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}
        </div>
        {/* 데이터 없을 때 */}
        {!isLoading && selectedDate && filteredData.length === 0 && (
            <div style={{
                textAlign: 'center',
                color: '#888',
                padding: '20px',
                flex:'1',
                display:'flex',
                alignItems:'center',
                justifyContent:'center',
                fontSize:'34px',
            }}>
                해당 날짜의 데이터가 없습니다.
            </div>
        )}
    </>
    );
}